/* eslint-disable max-len */
import * as React from 'react';
import { Loader, LoaderProps } from '@inwink/loader';

import "./inwinkspinner.less";

export interface IInwinkLoaderProps extends LoaderProps {
    size?: 'small' | 'standard' | 'big';
    animation?: 'spin' | 'headbounce';
}

export class InwinkSpinner extends React.Component<IInwinkLoaderProps, any> {
    render() {
        return <div className={"inwinkspinner size-" + (this.props.size || "standard") + (this.props.animation ? " animate-" + this.props.animation : "this.props.")}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110.91 110.91">
                <defs>
                    <style>
                        {".logoloader-bg { fill:#e94c1e;isolation:isolate;opacity:.9; transform-box: fill-box; transform-origin: center; }"}
                        {".logoloader-body-small, .logoloader-body, .logoloader-head { fill: white; transform-box: fill-box; transform-origin: center; } "}
                        {".logoloader-body, .logoloader-head { opacity: .8; }"}
                    </style>
                </defs>
                <g id="a"></g>
                <g id="b">
                    <g id="c">
                        <path className="logoloader-bg" d="M110.9,55.45c0,15.32,.51,33.15-10.89,44.59-11.4,11.44-29.25,10.86-44.56,10.86s-33.15,.51-44.59-10.89C-.58,88.62,0,70.77,0,55.45S-.5,22.3,10.9,10.86C22.3-.58,40.15,0,55.45,0s33.15-.5,44.59,10.9c11.44,11.4,10.86,29.25,10.86,44.55Z"></path>
                        <g>
                            <path className="logoloader-body" d="M54.48,84.02l16.38-28.38c2.34-4.06,.95-9.24-3.1-11.59-1.29-.75-2.76-1.14-4.25-1.14H30.75c-4.68,0-8.48,3.8-8.48,8.48,0,1.49,.39,2.95,1.14,4.24l16.38,28.38c2.34,4.06,7.53,5.45,11.59,3.11,1.29-.75,2.36-1.82,3.11-3.11Z"></path>
                            <path className="logoloader-body-small" d="M75.94,85.18l11.87-20.57c1.7-2.94,.69-6.7-2.25-8.4-.93-.54-1.99-.82-3.07-.82h-23.77c-3.4,0-6.14,2.77-6.13,6.17,0,1.07,.29,2.13,.82,3.06l11.88,20.57c1.7,2.94,5.47,3.95,8.41,2.24,.93-.54,1.71-1.31,2.24-2.24Z"></path>
                            <circle className="logoloader-head" cx="47.13" cy="30.68" r="8.03"></circle>
                        </g>
                    </g>
                </g>
            </svg>
        </div>;
    }
}